<template>
    <div class="inset">
        <div class="frame">
            <div class="artwork">
                <img src="~@/assets/logo-color.svg" alt="">
            </div>
            <div class="content">
                <p><strong>Open Source Score (OSS) is an educational tool and survey designed to gauge open source process experience and knowledge.</strong></p>
                <p>Once completed the tool does three things:</p>
                <ul>
                    <li>Generates a score of 0-100, with 0 being a low level of process knowledge and experience and 100 being high</li>
                    <li>Lets you know how your score compares to everyone that has taken the survey</li>
                    <li>Forwards educational links to open source educational resources</li>
                </ul>
            </div>
            <Btn block to="/survey">Take the Survey</Btn>
            <p class="sub">The survey takes ~2 minutes to complete.</p>
        </div>
    </div>
</template>

<script>
    import Btn from "@/components/Btn"

    export default {
        name: 'home',
        components : {
            Btn
        }
    }
</script>


<style lang="scss" scoped>
    @import "../scss/vars";

    .btn{
        font-size: 2rem;
        margin: 0 2rem;
        max-width: $b1 * 0.5;

        @media screen and (min-width: $b1 / 2){
            font-size: 3rem;
            margin: 0 auto;
        }
    }

    .inset{
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: calc( 100vh - 4rem );
        flex-direction: column;
    }

    .frame{
        text-align: center;
        padding: 4rem 0;
        border-radius: 4px;
        flex-grow: 1;
        min-height: 400px;
        max-width: $b1 * 0.7;
        margin: 0 auto;

        .content{
            background-color: white;
            padding: 2rem 2rem 1rem 2rem;
            border-radius: 4px;
            margin-bottom: 2rem;
            text-align: center;

            ul {
                margin:0; 
                padding: 0;
                text-align: left;
                @media screen and (min-width: $b1){
                    padding: 0 3rem;
                }
            }

            @media screen and (min-width: $b1){
                padding: 4rem 6rem 3rem 6rem;
                font-size: 1.8rem;
            }

            strong{
                font-size: 2rem;
                line-height: 2rem;

                @media screen and (min-width: $b1){
                    font-size: 2.2rem;
                    line-height: 2.2rem;
                }
            }
        }
    }

    .artwork{
        padding-bottom: 2rem;

        @media screen and (min-width: $b1){
            // padding-bottom: 6rem;
        }
    }

    .sub{
        font-size: 1.3rem;
        font-style: italic;
        color: $gray;
        text-align: center;
        padding: 1rem 2rem;
    }
</style>
